import { login, wxLogin } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { getUserInfo, updateUserInfo } from '@/api/user'
import { TUILogin } from '@tencentcloud/tui-core';
import { framework } from '@/TUIKit/adapter-vue';

const user = {
  state: {
    token: getToken('token'),
    imToken: getToken('imToken'),
    userInfo: {},
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_IM_TOKEN: (state, token) => {
      state.imToken = token
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
  },

  actions: {
    // 登录
    login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          setToken('token', response.data.access_token)
          commit('SET_TOKEN', response.data.access_token)
          setToken('imToken', response.data.im_token)
          commit('SET_IM_TOKEN', response.data.im_token)
          commit('SET_USER_INFO', response.data.user)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
// 登录
    wxLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        wxLogin(userInfo).then(response => {
          if(response.code !== 9) {
            setToken('token', response.data.access_token)
            commit('SET_TOKEN', response.data.access_token)
            setToken('imToken', response.data.im_token)
            commit('SET_IM_TOKEN', response.data.im_token)
            commit('SET_USER_INFO', response.data.user)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    getUserInfo({ commit, state }) {
      console.log("state", state)
      return new Promise((resolve, reject) => {
        
        getUserInfo().then(res => {
        console.log("res", res)

          commit('SET_USER_INFO', res.data)
          TUILogin.login({
            SDKAppID: 1600034392,
            userID: `${res.data.id}`,
            userSig: state.imToken,
            useUploadPlugin: false,
            framework,
          }).then(() => {})
          .catch((error) => {})
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 更新用户信息
    updateUserInfo({ commit, state }, userInfo) {
      return new Promise((resolve, reject) => {
        updateUserInfo(userInfo).then(res => {
          commit('SET_USER_INFO', res.data)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 退出系统
    loginOut({ commit, state }) {
      return new Promise((resolve, reject) => {
          commit('SET_TOKEN', '')
          commit('SET_IM_TOKEN', '')
          removeToken('token')
          removeToken('imToken')
          resolve()
      })
    },
  }
}

export default user
